/* eslint-disable camelcase */
import { IGetSlotsLastWinsPayload, tableTypesEnum } from 'shared/models/LastWins'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { LastWinsConverter } from './LastWinsConverter'

class LastWinsApi extends BaseHttpService {
  private converter

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/backoffice/win-table`
    this.converter = new LastWinsConverter()
  }

  async getSlotsLastWins(filters: Omit<IGetSlotsLastWinsPayload, 'table_type'> & { table_type: tableTypesEnum }) {
    const { table_type, ...data } = filters
    return this.sendQuery({
      type: QueryTypes.GET,
      url: `${this.baseUrl}/${table_type}/`,
      data,
      converterSuccess: this.converter.convertSlotsLastWins,
    })
  }

  async getPlayerPrivacySettings() {
    return this.sendQuery({
      type: QueryTypes.GET,
      url: `${this.baseUrl}/player-privacy-settings/`,
      converterSuccess: this.converter.convertPlayerPrivacySettings,
    })
  }
}

export default LastWinsApi
